"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArmored = exports.generateKeyPair = exports.readPrivateKey = void 0;
const openpgp = __importStar(require("openpgp"));
const addressparser_1 = __importDefault(require("addressparser"));
const readPrivateKey = (key) => __awaiter(void 0, void 0, void 0, function* () {
    const privateKey = yield openpgp.readKey({
        armoredKey: (yield (0, exports.isArmored)(key)) ? key : Buffer.from(key, 'base64').toString()
    });
    const address = yield privateKey.getPrimaryUser().then(primaryUser => {
        var _a;
        return (0, addressparser_1.default)((_a = primaryUser.user.userID) === null || _a === void 0 ? void 0 : _a.userID)[0];
    });
    return {
        fingerprint: privateKey.getFingerprint().toUpperCase(),
        keyID: privateKey.getKeyID().toHex().toUpperCase(),
        name: address.name,
        email: address.address,
        creationTime: privateKey.getCreationTime()
    };
});
exports.readPrivateKey = readPrivateKey;
const generateKeyPair = (name, email, passphrase, type) => __awaiter(void 0, void 0, void 0, function* () {
    const keyPair = yield openpgp.generateKey({
        userIDs: [{ name: name, email: email }],
        passphrase: passphrase,
        type: type
    });
    return {
        publicKey: keyPair.publicKey.replace(/\r\n/g, '\n').trim(),
        privateKey: keyPair.privateKey.replace(/\r\n/g, '\n').trim()
    };
});
exports.generateKeyPair = generateKeyPair;
const isArmored = (text) => __awaiter(void 0, void 0, void 0, function* () {
    return text.trimLeft().startsWith('---');
});
exports.isArmored = isArmored;
